module.exports = __webpack_public_path__ + "img/W-S62.2187318d.jpg";